import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import {
  AssetDto,
  type AssetSchemaDto,
} from '@/api';
import DatasetFieldChip from '@/modules/monitors/monitor/common/DatasetFieldChip.vue';
import DataQualityChip from '@/modules/catalog/asset/data-quality/DataQualityChip.vue';
import { type QualityItem, remapStatus } from '@/modules/catalog/asset/data-quality/data-quality';

interface AssetOverviewSchemaProps {
  schema: AssetSchemaDto;
  urn: AssetDto['urn'];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Asset-Overview-Schema',
  props: {
  schema: null,
  urn: null
},
  setup(__props) {

const props = __props;


const fields = _computed(() => {
  const schema = props.schema?.fields ? [...props.schema.fields] : [];
  return schema?.map((field) => ({
    name: field.name,
    typeCategory: field.typeCategory,
    dataQuality: remapStatus(field.ruleStatuses),
  })).sort((a: any, b: any) => a.name.localeCompare(b.name));
});

const fieldsCount = _computed(() => props.schema?.fields?.length ?? 0);
const to = _computed(() => ({
  name: 'data-catalog.asset.schema',
  params: { urn: props.urn },
}));

const rowColorClass = (dataQuality: QualityItem) => {
  if (!dataQuality) return '';
  if (dataQuality.failed) return 'bgDangerPrimary';
  if (dataQuality.needsAttention) return 'bgWarningPrimary';
  return '';
};

return { __sfc: true,props, fields, fieldsCount, to, rowColorClass, _computed, AssetDto, DatasetFieldChip, DataQualityChip, remapStatus }
}

})